import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TerminalService } from "../../services/terminal.service";
import { TerminalViewModel } from "../../models/terminal-view-model";
import { CreateResult } from "../../models/create-result";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { TaTermConfigViewModel } from "../../models/ta-term-config-view-model";
import { Select2OptionData } from "ng-select2";
import { AddUpdateTerminalViewModel } from "../../models/add-update-terminal-view-model";
import { ToastrService } from "ngx-toastr";
import { TerminalConfigService } from "../../services/terminal-config.service";
import { TerminalInteractionViewModel } from "../../models/terminal-interaction-view-model";
import { TerminalConfigViewModel } from '../../models/terminal-config-view-model';
import { AddUpdateTerminalInteractionViewModel } from '../../models/add-update-terminal-interaction-view-model';
import { ChangeDetectorRef } from '@angular/core';
import { InteractionTypeEnum } from '../../models/interaction-type-enum';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { AuthenticationService } from "../../services/authentication.service";
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TerminalParamViewModel } from "../../models/terminal-param-view-model";
import { FormatHelper } from "../../helpers/format-helper";
import { TerminalInteractionsViewModel } from '../../models/terminal-interactions-view-model';
import { TerminalDetailModel } from 'src/app/models/terminal-detail-model';
import { ParticipantService } from "../../services/participant.service";
import { ProductProfileService } from "../../services/product-profile.service";
import { TerminalCapabilityService } from "../../services/terminal-capability.service";
import { CommsProfileService } from "../../services/comms-profile.service";
import { CustomTagService } from '../../services/custom-tag.service';
import { TerminalGroupsByParticipantLinkViewModel } from '../../models/terminal-groups-participant-link';
import { TerminalGroupViewModel } from '../../models/terminal-group-view-model';
import { CustomTagsParticipantLinkViewModel } from '../../models/custom-tags-participant-link';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { async } from 'rxjs/internal/scheduler/async';
import { AccountTypeEnum } from '../../models/account-type-enum';
import { AddUpdateESocketViewModel } from '../../models/add-update-eSocket-view-model';
import { RetailerConfigViewModel } from '../../models/terminal-config-retailer-view-model';
import { TerminalInfoModel } from '../../models/terminal-info-model';
import { AddUpdateTerminalWithSerialNumberViewModel } from "../../models/add-update-terminal-with-serial-number-view-model";

@Component({
  selector: 'app-terminal-view',
  templateUrl: './terminal-view.component.html',
  styleUrls: ['./terminal-view.component.scss']
})

export class TerminalViewComponent implements OnInit, OnDestroy {

  public terminalForm: FormGroup;
  public submitted = false;
  public id: string;
  public terminal: TerminalViewModel;
  public terminalSelectedConfig: TerminalDetailModel;
  public createResult: CreateResult;
  public taTermCfg: TaTermConfigViewModel;
  private _destroyed$ = new Subject<any>();
  public error = false;
  public errorMessage = "";
  public creatingNew: boolean = false;
  public TermConfigType: number;
  public terminalConfig: number;
  public laneProfileItems: Select2OptionData[];
  public storesItems: Select2OptionData[];
  public eSocket: number = 3;
  public displayEscoket: boolean;
  public PostTerm: number = 2;
  public TermApp: number = 1;

  public termTypes: Select2OptionData[] = [];
  public productProfiles: Select2OptionData[] = [];
  public capabilityProfiles: Select2OptionData[] = [];
  public commsProfiles: Select2OptionData[] = [];
  public terminalConfigsSelect2: Select2OptionData[] = [];
  private terminalConfigs: TerminalConfigViewModel[] = [];
  public parameterDownloadInteractionDays: Select2OptionData[] = [
    { id: "1", text: 'Sunday' },
    { id: "2", text: 'Monday' },
    { id: "4", text: 'Tuesday' },
    { id: "8", text: 'Wednesday' },
    { id: "15", text: 'Thursday' }
  ];
  public terminalInteractionBankingWindowTimes: Select2OptionData[] = [
    { id: "", text: "" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" },
    { id: "07:30 - 08:00", text: "07:30 - 08:00" },
    { id: "08:00 - 08:30", text: "08:00 - 08:30" },
    { id: "08:30 - 09:00", text: "08:30 - 09:00" },
    { id: "09:00 - 09:30", text: "09:00 - 09:30" },
    { id: "09:30 - 10:00", text: "09:30 - 10:00" },
    { id: "10:00 - 10:30", text: "10:00 - 10:30" },
    { id: "10:30 - 11:00", text: "10:30 - 11:00" },
    { id: "11:00 - 11:30", text: "11:00 - 11:30" },
    { id: "11:30 - 12:00", text: "11:30 - 12:00" },
    { id: "12:00 - 12:30", text: "12:00 - 12:30" },
    { id: "12:30 - 13:00", text: "12:30 - 13:00" },
    { id: "13:00 - 13:30", text: "13:00 - 13:30" },
    { id: "13:30 - 14:00", text: "13:30 - 14:00" },
    { id: "14:00 - 14:30", text: "14:00 - 14:30" },
    { id: "14:30 - 15:00", text: "14:30 - 15:00" },
    { id: "15:00 - 15:30", text: "15:00 - 15:30" },
    { id: "15:30 - 16:00", text: "15:30 - 16:00" },
    { id: "16:00 - 16:30", text: "16:00 - 16:30" },
    { id: "16:30 - 17:00", text: "16:30 - 17:00" },
    { id: "17:00 - 17:30", text: "17:00 - 17:30" },
    { id: "17:30 - 18:00", text: "17:30 - 18:00" },
    { id: "18:00 - 18:30", text: "18:00 - 18:30" },
    { id: "18:30 - 19:00", text: "18:30 - 19:00" },
    { id: "19:00 - 19:30", text: "19:00 - 19:30" },
    { id: "19:30 - 20:00", text: "19:30 - 20:00" },
    { id: "20:00 - 20:30", text: "20:00 - 20:30" },
    { id: "20:30 - 21:00", text: "20:30 - 21:00" },
    { id: "21:00 - 21:30", text: "21:00 - 21:30" },
    { id: "21:30 - 22:00", text: "21:30 - 22:00" },
    { id: "22:00 - 22:30", text: "22:00 - 22:30" },
    { id: "22:30 - 23:00", text: "22:30 - 23:00" },
    { id: "23:00 - 23:30", text: "23:00 - 23:30" }
  ];
  public terminalInteractionParameterTimes: Select2OptionData[] = [
    { id: "23:00 - 23:30", text: "23:00 - 23:30" },
    { id: "23:30 - 00:00", text: "23:30 - 00:00" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" }
  ];

  public canView: boolean = false;
  public canEdit: boolean = false;
  public canAdd: boolean = false;
  public canDelete: boolean = false;
  public canAddManualPanEntry: boolean = false;
  public AddEditButton: string;
  public DeleteButton: string;
  public canAddTerminalInteraction: boolean = false;
  public canViewTerminalInteraction: boolean = false;
  public TerminalInteractionDisplay: string;
  public disableInteractions: boolean;
  public isDisabled: boolean;
  public createTerminal: boolean;
  public disableCustomParamValue: boolean;

  public select2options: any = {
    multiple: false,
    width: '100%'
  };

  public terminalInteractions: TerminalInteractionViewModel[];
  public terminalInteractionsDetails: TerminalInteractionsViewModel[];
  public bankingWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public parameterDownloadWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public eSocketTerminal: AddUpdateESocketViewModel;
  public terminalView: TerminalViewModel;
  public terminalDetails: TerminalDetailModel;
  public terminalInfo: TerminalInfoModel;
  public terminalUpdate: AddUpdateTerminalViewModel;
  public terminalUpdateWithSerialNumber: AddUpdateTerminalWithSerialNumberViewModel;
  public contactlessTerminalParam: TerminalParamViewModel;
  public displayContent: boolean;
  public editExistingContent: boolean;
  public manualPanEntry: boolean;

  public canEditTerminalType: boolean;
  public canEditProductProfile: boolean;
  public canEditTerminalCapability: boolean;
  public canEditCommsProfile: boolean;
  public canEditTerminalActive: boolean;
  public canEditTerminalContactLess: boolean;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  private loaded = false;
  private globalSearch = false;
  private selectedParticipantId = 0;
  private getSerialNumber = "";
  public disabled: boolean = true;
  public warning: string;
  public raiseWarning: boolean;
  public danger: string;
  public raiseDanger: boolean;
  public displayMPOSContent: boolean;

  public hasCustomTags: boolean;
  public terminalGroups: Select2OptionData[];
  public TerminalGroupsByParticipant: TerminalGroupsByParticipantLinkViewModel[] = [];
  public mapTerminalGroupTags: Select2OptionData[];
  public selectedGroup: string;
  public terminalGroupMappedFields: TerminalGroupViewModel[] = [];
  public mappedFieldsGroupFC: { formControl: FormControl, terminalGroupMappedFields: TerminalGroupViewModel }[] = [];
  public terminalParamMappedFields: CustomTagsParticipantLinkViewModel[] = [];
  public mappedFieldsFC: { formControl: FormControl, terminalParamMappedFields: CustomTagsParticipantLinkViewModel }[] = [];
  public termConfigId: number;
  public selectedTerminalGroup: string;
  public globalTerminalGroup: string;
  public noCustomParamterSet: boolean;
  public noCustomParamterMessage: string;
  public groupExist: Boolean = false;
  public tagExist: Boolean = false;
  public EditCustomParam: string;
  public cssClass: string;
  public EditCustomParamValue: string;
  public getRetailer: RetailerConfigViewModel;
  public isSerialNrVisible: boolean = true;


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _participantService: ParticipantService,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _terminalConfigService: TerminalConfigService,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private fb: FormBuilder,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _formBuilder: FormBuilder,
    private _formatHelper: FormatHelper,
    private _customTagService: CustomTagService) {

    this.globalSearch = sessionStorage.getItem('terminalGlobalSearch') === 'true';

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      let bankingWindow;
      let parameterDownloadWindow;

      let bankingWindowDetail;
      let parameterDownloadWindowDetail;
      this.selectedParticipantId = _userDataStore.selectedParticipant.id;
      this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminal], []);
      if (!this.canView) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      debugger;
      this.canViewTerminalInteraction = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalInteraction], []);
      if (!this.canViewTerminalInteraction) {
        this.disableInteractions = true;
      }

      this.isSerialNrVisible = false;

      if (this.globalSearch) {

        const terminalView = await this._terminalService.GetTerminalView(params['id']);
        this.selectedParticipantId = terminalView.participantId ?? 0;
        this.terminalConfigs = await this._terminalConfigService.GetConfigsByParticipantId(this.selectedParticipantId);

        this.productProfiles = (await this._productProfileService.GetProductProfilesByParticipantOrAll(this.selectedParticipantId)).map((x) => {
          return { id: x.profileId.toString(), text: x.productProfile }
        });

        this.capabilityProfiles = (await this._terminalCapabilityService.GetTerminalCapabilitiesByParticipant(this.selectedParticipantId)).map((x) => {
          return { id: x.capabilityProfileId.toString(), text: x.capabilityProfileName }
        });

        this.commsProfiles = (await this._commsProfileService.GetCommsProfilesByParticipant(this.selectedParticipantId)).map((x) => {
          return { id: x.commsProfileId.toString(), text: x.description }
        });

      }
      else {
        this.terminalConfigs = await this._terminalConfigService.GetAllConfigs();

        this.productProfiles = (await this._productProfileService.GetProductProfilesForParticipantOrAll()).map((x) => {
          return { id: x.profileId.toString(), text: x.productProfile }
        });

        this.capabilityProfiles = (await this._terminalCapabilityService.GetTerminalCapabilitiesForParticipantOrAll()).map((x) => {
          return { id: x.capabilityProfileId.toString(), text: x.capabilityProfileName }
        });

        this.commsProfiles = (await this._commsProfileService.GetCommsProfilesForParticipantOrAll()).map((x) => {
          return { id: x.commsProfileId.toString(), text: x.description }
        });
      }

      this.terminalConfigsSelect2 = (this.terminalConfigs).map((x) => {
        return { id: x.id.toString(), text: x.name }
      });

      this.termTypes = (await this._terminalService.GetTermTypes()).map((x) => {
        return { id: x.id.toString(), text: x.name }
      });

      if (params.id == 'new' || !params.id) {

        this.terminal = {
          id: null,
          cardAcceptor: "",
          dateDeployed: undefined,
          hardwareConfig: "",
          lastMessageType: "",
          mediaTeam: 0,
          miscellaneous: "",
          participantId: 0,
          posDataCode: "",
          posGeographicData: "",
          securityTeam: 0,
          serialNr: "",
          shortName: "",
          sponsorBank: "",
          status: "",
          suppliesTeam: 0,
          supportTeam: 0,
          termActive: 0,
          termMode: 0,
          termType: 0,
          valueBars: "",
          worstEventSeverity: 0
        };

        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);
        if (!this.canAdd) {
          this.AddEditButton = "display:none";
        }
        this.DeleteButton = "display:none";
        this.creatingNew = true;

        if (this.terminalConfig != undefined) {
          this.terminalForm.controls['']
        }
        else {
          this.loaded = true;
          this.updateForm();
        }

        this.manualPanEntry = false;
        this.editExistingContent = true;
        this.disabled = false;
        this.selectedGroup = '';


      }
      else {
        debugger;
        this._ngxUiLoaderService.start();

        this.selectedGroup = '';
        this.creatingNew = false;
        this.updateForm();

        this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminal], []);
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);
        this.canDelete = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteTerminal], []);
        if (!this.canDelete) {
          this.DeleteButton = "display:none";
        }

        this.id = params.id;
        this.terminal = await this._terminalService.Get(this.id);
        this.terminalSelectedConfig = await this._terminalConfigService.GetTerminalDetail(this.id);
        this.terminalDetails = await this._terminalService.GetTerminalDetails(this.id);
        this.terminalInfo = await this._terminalService.GetTerminalInfo(this.id);

        if (this.terminal.termType == 350) {
          this.taTermCfg = await this._terminalService.GetTaTermCfg(this.id);
          this.terminalInteractions = await this._terminalService.GetTerminalInteractions(this.id);
          this.contactlessTerminalParam = await this._terminalService.GetLastContactlessParam(this.id);
          this.terminalInteractionsDetails = await this._terminalService.GetTerminalInteractionsDetails(this.id);
          this.isSerialNrVisible = await this._terminalService.IsSerialNrVisible(this.selectedParticipantId);

          bankingWindow = this.terminalInteractions.find(ti => ti.interactionType == 1);
          parameterDownloadWindow = this.terminalInteractions.find(ti => ti.interactionType == 2);
          //check if terminal interaction exist
          if (this.terminalInteractions.length > 0 && this.terminalInteractionsDetails.length == 0) {

            this.parameterDownloadWindowUpdate = {
              terminalId: this.id,
              BankingWindow: parameterDownloadWindow?.interactionType,
              InteractionDay: parameterDownloadWindow?.weekdays,
              InteractionTime: parameterDownloadWindow?.interactionDate
            };
            this.createResult = await this._terminalService.AddUpdateTerminalInteractions(InteractionTypeEnum.ParameterDownload, this.parameterDownloadWindowUpdate);


            this.bankingWindowUpdate = {
              terminalId: this.id,
              BankingWindow: bankingWindow?.interactionType,
              InteractionDay: 0,
              InteractionTime: bankingWindow?.interactionDate
            };
            this.createResult = await this._terminalService.AddUpdateTerminalInteractions(InteractionTypeEnum.BankingWindow, this.bankingWindowUpdate);

          }

          //Do a last round check
          this.terminalInteractionsDetails = await this._terminalService.GetTerminalInteractionsDetails(this.id);

          if (this.terminalInteractionsDetails.length > 0) {
            if (this.terminalInteractionsDetails.find(ti => ti.interactionType == 1) != null) {
              bankingWindowDetail = this.terminalInteractionsDetails.find(ti => ti.interactionType == 1).slot;
            }
            if (this.terminalInteractionsDetails.find(ti => ti.interactionType == 2) != null) {
              parameterDownloadWindowDetail = this.terminalInteractionsDetails.find(ti => ti.interactionType == 2).slot;
            }
          }

        }
        if (this.taTermCfg != null) {
          this.displayContent = true;
          this.displayMPOSContent = true;
          //Manual Pan Entry
          this.manualPanEntry = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddManualPanEntry, PermissionEnum.EditManualPanEntry, PermissionEnum.ViewManualPanEntry], []);
        }
        else if (this.terminal.termType == 22) {
          //Manual Pan Entry
          this.manualPanEntry = false;
          this.displayMPOSContent = true;
        }
        else if (this.terminal.termType == 103) {
          this.displayEscoket = true;
          this.displayMPOSContent = true;
          this.manualPanEntry = false;
          debugger;
          this.eSocketTerminal = await this._terminalService.GetESocketTerminalDetails(this.id);
          this.isSerialNrVisible = true;
          this.getRetailer = await this._terminalConfigService.GetRetailer(this.selectedParticipantId, this.terminalDetails.terminalConfigId);
          if (this.getRetailer != null) {
            {
              debugger;
              var getStores = await this._terminalConfigService.GetStoreByRetailerId(this.getRetailer.retailerId);
              if (getStores != null) {
                this.storesItems = (getStores).map((x) => {
                  return { id: x.storeId, text: x.storeId }
                });
              }
              var getLaneProfiles = await this._terminalConfigService.GetLaneProfilesByRetailer(this.getRetailer.retailerId);
              if (getLaneProfiles != null) {
                this.laneProfileItems = (getLaneProfiles).map((x) => {
                  return { id: x.laneProfile.toString(), text: x.laneProfile.toString() }
                });
              }
            }
          }

          this.terminalForm.controls['serialNumber'].disable();
        }
        //hide terminal config field since you editing an existing terminal
        this.editExistingContent = false;
        this.disabled = true;

        this._ngxUiLoaderService.stop();
      }

      this.terminalUpdate = {
        terminalConfigId: 1,
        terminalId: this.terminal?.id,
        merchantNumber: this.terminal.cardAcceptor,
        terminalType: this.terminal.termType,
        terminalNumber: null,
        productProfile: null,
        terminalCapabilities: null,
        commsProfile: null,
        manualPanEntry: false,
        terminalActive: this.terminal.termActive == 1,
        contactless: !!this.contactlessTerminalParam && !!this.contactlessTerminalParam.valueOnServer,
      };

      let bankingWindowTime = bankingWindowDetail;
      let paramWindowTime = parameterDownloadWindowDetail;

      if (params.id == 'new' || !params.id) {
        this.terminalForm = this._formBuilder.group({
          id: [this.id || null],
          merchantNumber: [this.terminal?.cardAcceptor, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
          terminalId: [this.terminal?.id, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
          terminalConfig: [this.terminalSelectedConfig?.terminalConfigId == null],
          terminalNumber: [this.taTermCfg?.termNr, [Validators.required, Validators.minLength(1), Validators.maxLength(4)]],
          terminalType: [this.terminal?.termType || 350, [Validators.required]],
          productProfile: ['', [Validators.required]],
          terminalCapabilities: ['', [Validators.required]],
          commsProfile: ['', [Validators.required]],
          isTerminalActive: [this.terminal?.termActive == 1, [Validators.required]],
          isManualPan: [this.taTermCfg?.functionVector == 3, [Validators.required]],
          isContactless: [!!this.contactlessTerminalParam && parseInt(this.contactlessTerminalParam.valueOnServer), [Validators.required]],
          bankingWindowTime: ['', [Validators.required]],
          bankingWindowConn: [{ value: bankingWindow?.maxConnAttempts || '3', disabled: true }, [Validators.required]],
          bankingWindowWait: [{ value: bankingWindow?.retryInterval || '5', disabled: true }, [Validators.required]],
          parameterDownloadWindowDay: ['', [Validators.required]],
          parameterDownloadWindowTime: ['', [Validators.required]],
          parameterDownloadWindowConn: [{ value: parameterDownloadWindow?.maxConnAttempts || '2', disabled: true }, [Validators.required]],
          parameterDownloadWindowWait: [{ value: parameterDownloadWindow?.retryInterval || '200', disabled: true }, [Validators.required]],
          storeId: ['', [Validators.required]],
          laneProfile: ['', [Validators.required]],
          serialNumber: ['', [Validators.required]]
        });
      }
      else {

        this.terminalForm = this._formBuilder.group({
          id: [this.id || null],
          merchantNumber: [{ value: this.terminal?.cardAcceptor, disabled: true }, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
          terminalId: [{ value: this.terminal?.id, disabled: true }, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
          terminalConfig: [this.terminalSelectedConfig?.terminalConfigId == null],
          terminalNumber: [{ value: this.taTermCfg?.termNr, disabled: true }, [Validators.required, Validators.minLength(1), Validators.maxLength(4)]],
          terminalType: [this.terminal?.termType || 350, [Validators.required]],
          productProfile: [this.taTermCfg?.productProfileId, [Validators.required]],
          terminalCapabilities: [this.taTermCfg?.capabilityProfileId, [Validators.required]],
          commsProfile: [this.taTermCfg?.commsProfileId, [Validators.required]],
          isTerminalActive: [this.terminal?.termActive == 1, [Validators.required]],
          isManualPan: [this.taTermCfg?.functionVector == 3, [Validators.required]],
          isContactless: [!!this.contactlessTerminalParam && parseInt(this.contactlessTerminalParam.valueOnServer), [Validators.required]],
          bankingWindowTime: [bankingWindowTime, [Validators.required]],
          bankingWindowConn: [{ value: bankingWindow?.maxConnAttempts || '3', disabled: true }, [Validators.required]],
          bankingWindowWait: [{ value: bankingWindow?.retryInterval || '5', disabled: true }, [Validators.required]],
          parameterDownloadWindowDay: [parameterDownloadWindow?.weekdays, [Validators.required]],
          parameterDownloadWindowTime: [paramWindowTime, [Validators.required]],
          parameterDownloadWindowConn: [{ value: parameterDownloadWindow?.maxConnAttempts || '2', disabled: true }, [Validators.required]],
          parameterDownloadWindowWait: [{ value: parameterDownloadWindow?.retryInterval || '200', disabled: true }, [Validators.required]],
          storeId: [this.eSocketTerminal?.store, [Validators.required]],
          laneProfile: [this.eSocketTerminal?.laneProfile, [Validators.required]],
          serialNumber: [this.terminal.serialNr, [Validators.required]]
        });

      }

      this.UserPermissions();

      if (this.terminalSelectedConfig != null && this.terminal != null) {
        this.terminalForm.controls['merchantNumber'].disable();
        this.terminalForm.controls['terminalId'].disable();
        this.terminalForm.controls['terminalNumber'].disable();

        if (this.terminal.termType == 103) {

          this.terminalForm.controls['serialNumber'].disable();
        }
        //  this.terminalForm.controls['isTerminalActive'].disable();
      }


      if (!this.canEdit && !this.canAdd) {
        this.AddEditButton = "display:none";
        this.warning = "Please note that you do not have the required permissions to Edit/Save this page.";
        this.raiseWarning = false;

        Object.keys(this.terminalForm.controls).forEach(key => {
          this.terminalForm.controls[key].disable();
        });
      }


      this.loaded = true;

      //custom parameters

      if (this.terminalSelectedConfig != null) {

        this.termConfigId = this.terminalSelectedConfig.terminalConfigId;
        this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this._userDataStore.selectedParticipant.id, Number(this.terminalSelectedConfig.terminalConfigId));
        if (this.TerminalGroupsByParticipant.length > 0) {
          this.hasCustomTags = true;

          this.terminalGroups = (this.TerminalGroupsByParticipant).map((x) => {
            return { id: x.groupName.toString(), text: x.groupName }
          });

          if (params.id != 'new') {
            this.terminalGroupMappedFields = await this._customTagService.GetRTTerminalGroupsByTerminalId(params.id);

            if (this.terminalGroupMappedFields.length > 0) {

              for (var i = 0; i < this.terminalGroupMappedFields.length; i++) {
                const mappedGroupFields = {
                  term_group_name: this.terminalGroupMappedFields[i].term_group_name,
                  tag: '',
                  fileId: '',
                  valueOnServer: '',
                  lastUpdated: null,
                  valueStatus: 0
                };
                const fc = new FormControl();
                //fc.setValue(mappedFields.mappedCardAcceptorId);

                this.mappedFieldsGroupFC.push({ formControl: fc, terminalGroupMappedFields: mappedGroupFields });
              }
            }
          }
          this.filterTerminalGroups();
        }
      }
      else {
        this.hasCustomTags = false;
      }

    });
  }


  private UserPermissions() {

    var userType = this._userDataStore.accountType
    if (userType == AccountTypeEnum.SystemAdministrator) {
      this.canEditTerminalType = true;
      this.canEditProductProfile = true;
      this.canEditTerminalCapability = true;
      this.canEditCommsProfile = true;
      this.terminalForm.controls['isTerminalActive'].enable();
      this.terminalForm.controls['isContactless'].enable();
    }
    else {
      this.canEditTerminalType = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToTerminalType], []);
      this.canEditProductProfile = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToProductProfile], []);
      this.canEditTerminalCapability = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToTerminalCapability], []);
      this.canEditCommsProfile = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToCommsProfile], []);

      this.canEditTerminalActive = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToTerminalStatus], []);
      if (!this.canEditTerminalActive) {
        this.terminalForm.controls['isTerminalActive'].disable();
      }

      this.canEditTerminalContactLess = this._userDataStore.hasRequiredPermissions([PermissionEnum.HasAccessToContactLess], []);
      if (!this.canEditTerminalContactLess) {
        this.terminalForm.controls['isContactless'].disable();
      }
    }
  }

  public async ngOnInit() {

    this.terminalForm = this._formBuilder.group({
      id: [this.id || null],
      merchantNumber: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      terminalId: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      terminalConfig: [''],
      terminalNumber: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(4)]],
      terminalType: ['' || 350, [Validators.required]],
      productProfile: ['', [Validators.required]],
      terminalCapabilities: ['', [Validators.required]],
      commsProfile: ['', [Validators.required]],
      isTerminalActive: [0, [Validators.required]],
      isManualPan: [0, [Validators.required]],
      isContactless: [0, [Validators.required]],
      bankingWindowTime: ['', [Validators.required]],
      bankingWindowConn: ['', [Validators.required]],
      bankingWindowWait: ['', [Validators.required]],
      parameterDownloadWindowDay: ['', [Validators.required]],
      parameterDownloadWindowTime: ['', [Validators.required]],
      parameterDownloadWindowConn: ['', [Validators.required]],
      parameterDownloadWindowWait: ['', [Validators.required]],
      storeId: ['', [Validators.required]],
      laneProfile: ['', [Validators.required]],
      serialNumber: ['', [Validators.required]]
    });
  }

  public updateForm(): void {

    if (this.loaded == true) {
      this._ngxUiLoaderService.start();
      setTimeout(async () => {
        var selectedvalue = this.terminalForm.controls.terminalConfig.value;

        if (selectedvalue == '' || selectedvalue == null) {
          this.manualPanEntry = false;
          this.displayContent = false;
          this.displayMPOSContent = false;
          this.hasCustomTags = false;
        }
        else {

          const selectedConfig = this.terminalConfigs.find((x) => { return x.id == selectedvalue });

          if (!!selectedConfig && selectedConfig.configType > 0)//(!!this.terminalUpdate.terminalConfigId) {
          {
            this.TermConfigType = selectedConfig.configType;
          }

          this.terminalUpdate.terminalConfigId = selectedConfig?.id;


          if (this.TermConfigType == this.PostTerm) {
            this.displayEscoket = false;
            this.displayContent = false;
            this.displayMPOSContent = true;
            this.manualPanEntry = false;
            this.hasCustomTags = false;
            this.termConfigId = selectedConfig?.id;
            this.isSerialNrVisible = false;
            this.terminalUpdate.terminalNumber = null;
            this.terminalUpdate.commsProfile = null;
            this.terminalUpdate.manualPanEntry = null;
            this.terminalUpdate.terminalCapabilities = null;
            this.terminalUpdate.terminalType = 22;
            this.terminalUpdate.productProfile = null;

            this.bankingWindowUpdate = null;
            this.parameterDownloadWindowUpdate = null;
            this.raiseDanger = false;
          }
          else if (this.TermConfigType == this.TermApp) {

            this.isSerialNrVisible = await this._terminalService.IsSerialNrVisible(this.selectedParticipantId);
            this.displayEscoket = false;
            this.displayContent = true;
            this.displayMPOSContent = true;
            this.terminalUpdate.terminalType = 350;
            this.manualPanEntry = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddManualPanEntry, PermissionEnum.EditManualPanEntry, PermissionEnum.ViewManualPanEntry], []);
            this.raiseDanger = false;

            this.canAddTerminalInteraction = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalInteraction], []);
            if (!this.canAddTerminalInteraction) {
              this.raiseDanger = true;
              this.danger = "You do not have the permissions to add terminal interactions, should you wish to continue configuring a new terminal, a terminal will be flagged as inactive untill you set up terminal interactions. Please contact system administrator.";
            }


            if (this.terminalUpdate.terminalConfigId != null) {

              this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this._userDataStore.selectedParticipant.id, Number(this.terminalUpdate.terminalConfigId));
              if (this.TerminalGroupsByParticipant.length > 0) {
                this.termConfigId = Number(this.terminalUpdate.terminalConfigId);
                this.hasCustomTags = true;
                //terminal groups
                this.terminalGroups = (this.TerminalGroupsByParticipant).map((x) => {
                  return { id: x.groupName.toString(), text: x.groupName }
                });

                this.mapTerminalGroupTags = (this.TerminalGroupsByParticipant).map((x) => {
                  return { id: x.groupName.toString(), text: x.groupName }
                });
              }
              else {
                this.hasCustomTags = false;

              }
            }
          }
          else if (this.TermConfigType == this.eSocket) {

            this.isSerialNrVisible = await this._terminalService.IsSerialNrVisible(this.selectedParticipantId);
            this.displayMPOSContent = true;
            this.displayEscoket = true;
            this.manualPanEntry = false;
            this.hasCustomTags = false;
            this.termConfigId = selectedConfig?.id;
            this.terminalUpdate.terminalNumber = null;
            this.terminalUpdate.commsProfile = null;
            this.terminalUpdate.manualPanEntry = null;
            this.terminalUpdate.terminalCapabilities = null;
            this.terminalUpdate.terminalType = 103;
            this.terminalUpdate.productProfile = null;
            this.isSerialNrVisible = true;
            this.displayContent = false;
            this.bankingWindowUpdate = null;
            this.parameterDownloadWindowUpdate = null;
            this.raiseDanger = false;

            this.getRetailer = await this._terminalConfigService.GetRetailer(this._userDataStore.selectedParticipant.id, this.terminalUpdate.terminalConfigId);
            if (this.getRetailer != null) {
              {
                debugger;
                var getStores = await this._terminalConfigService.GetStoreByRetailerId(this.getRetailer.retailerId);
                if (getStores != null) {
                  this.storesItems = (getStores).map((x) => {
                    return { id: x.storeId, text: x.storeId }
                  });
                }

                var getLaneProfiles = await this._terminalConfigService.GetLaneProfilesByRetailer(this.getRetailer.retailerId);
                if (getLaneProfiles != null) {
                  this.laneProfileItems = (getLaneProfiles).map((x) => {
                    return { id: x.laneProfile.toString(), text: x.laneProfile.toString() }
                  });
                }

              }
            }
          }
          else {
            this.raiseDanger = false;
          }
        }

      }, 2000);
      this._ngxUiLoaderService.stop();
    }
  }

  public async saveTerminal(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.terminalForm.controls['isTerminalActive'].enable();
    this.terminalForm.controls['isContactless'].enable();
    debugger;
    this.terminalUpdate = {
      terminalId: this.terminalForm.value['terminalId'],
      merchantNumber: this.terminalForm.value['merchantNumber'],
      terminalType: parseInt(this.terminalForm.value['terminalType']) || 0,
      terminalNumber: parseInt(this.terminalForm.value['terminalNumber']) || 0,
      productProfile: parseInt(this.terminalForm.value['productProfile']) || 0,
      terminalCapabilities: parseInt(this.terminalForm.value['terminalCapabilities']) || 0,
      commsProfile: parseInt(this.terminalForm.value['commsProfile']) || 0,
      manualPanEntry: !!this.terminalForm.value['isManualPan'],
      terminalActive: !!this.terminalForm.value['isTerminalActive'],
      contactless: !!this.terminalForm.value['isContactless'],
      terminalConfigId: parseInt(this.terminalForm.value['terminalConfig']) || 0
    };

    this.bankingWindowUpdate = {
      terminalId: this.terminalForm.value['terminalId'],
      InteractionDay: Number(this.terminalForm.value['parameterDownloadWindowDay']),
      BankingWindow: this.terminalForm.value['bankingWindowTime'],
      InteractionTime: this.terminalForm.value['bankingWindowTime']
    };

    this.parameterDownloadWindowUpdate = {
      terminalId: this.terminalForm.value['terminalId'],
      InteractionDay: Number(this.terminalForm.value['parameterDownloadWindowDay']),
      BankingWindow: this.terminalForm.value['parameterDownloadWindowTime'],
      InteractionTime: this.terminalForm.value['parameterDownloadWindowTime']
    };

    this.eSocketTerminal = {
      id: 0,
      retailer: this.getRetailer?.retailerId,
      store: this.terminalForm.controls['storeId'].value,
      laneProfile: this.terminalForm.controls['laneProfile'].value,
      terminalId: this.terminalForm.controls['terminalId'].value,
      merchantNumber: this.terminalForm.controls['merchantNumber'].value,
      serialNumber: this.terminalForm.controls['serialNumber'].value,
      terminalConfigId: parseInt(this.terminalForm.value['terminalConfig']) || 0,
    };

    this.terminalDetails = {
      terminalId: this.terminalForm.controls['terminalId'].value,
      terminalConfigId: this.terminalDetails?.terminalConfigId,
      terminalNumber: this.terminalForm.controls['terminalNumber'].value,
    }

    this.terminalInfo = {
      terminalId: this.terminalForm.controls['terminalId'].value,
      termType: this.terminalForm.controls['terminalType'].value,
      termActive: this.terminalForm.controls['isTerminalActive'].value,
      cardAcceptor: this.terminalForm.controls['merchantNumber'].value,
      nameLocation: null,
      partcipantId: this.selectedParticipantId,
      terminalSerial: this.terminalForm.controls['serialNumber'].value,
      messageType: null,
      lastTransactionDate: null,
      lastUpdate: null,
    }

    this.submitted = true;
    if (!this.id) {
      this.terminalUpdate.terminalConfigId = +this.terminalUpdate.terminalConfigId;
    }

    if (!this.creatingNew) {
      //update terminal
      this.terminalUpdate.merchantNumber = this.terminal.cardAcceptor;
      this.terminalUpdate.terminalId = this.terminal.id;
      if (this.terminalSelectedConfig != null) {
        this.terminalUpdate.terminalConfigId = this.terminalSelectedConfig.terminalConfigId;
      }
      else {
        this.terminalUpdate.terminalConfigId = 0;
      }
      this.bankingWindowUpdate.terminalId = this.terminal.id;
      this.parameterDownloadWindowUpdate.terminalId = this.terminal.id;


      this.createResult = await this._terminalService.Update(this.terminalUpdate);
      if (this.createResult.success === true) {
        this._toastService.success(this.createResult.message, "Success");

        //update ContactLess
        if (this.contactlessTerminalParam) {
          this.createResult = await this._terminalService.SetTerminalParam(this.contactlessTerminalParam);
          if (this.createResult.success === true) {
            this._toastService.success(this.createResult.message, "Success");
          } else {
            this._toastService.error(this.createResult.message, "Error");
          }
        }


        if (this.taTermCfg != null) {

          if (!this.disableInteractions) {
            //Update Terminal interactions
            this.terminalInteractions = await this._terminalService.GetTerminalInteractions(this.id);
            if (this.terminalInteractions.length == 0) {

              //Update banking window
              if (this.terminalForm.controls['bankingWindowTime'].status == "VALID") {
                this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.BankingWindow, this.bankingWindowUpdate);
                if (this.createResult.success === true) {
                  this._toastService.success(this.createResult.message, "Success");
                } else {
                  this._toastService.error(this.createResult.message, "Error");
                }
              }

              //update Parameter downloads
              if (this.terminalForm.controls['parameterDownloadWindowDay'].status == "VALID" && this.terminalForm.controls['parameterDownloadWindowTime'].status == "VALID") {
                this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.ParameterDownload, this.parameterDownloadWindowUpdate);
                if (this.createResult.success === true) {
                  this._toastService.success(this.createResult.message, "Success");
                } else {
                  this._toastService.error(this.createResult.message, "Error");
                }
              }

            }
            else {

              var bankingWindow = this.terminalInteractions.find(ti => ti.interactionType == 1);
              var parameterDownloadWindow = this.terminalInteractions.find(ti => ti.interactionType == 2);

              if (bankingWindow != null) {
                if (this.terminalForm.controls['bankingWindowTime'].status == "VALID") {
                  //update banking window
                  this.createResult = await this._terminalService.UpdateTerminalInteraction(InteractionTypeEnum.BankingWindow, this.bankingWindowUpdate);
                  if (this.createResult.success === true) {
                    this._toastService.success(this.createResult.message, "Success");
                  } else {
                    this._toastService.error(this.createResult.message, "Error");
                  }
                }
              }
              else {
                if (this.terminalForm.controls['bankingWindowTime'].status == "VALID") {
                  //Add banking window
                  this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.BankingWindow, this.bankingWindowUpdate);
                  if (this.createResult.success === true) {
                    this._toastService.success(this.createResult.message, "Success");
                  } else {
                    this._toastService.error(this.createResult.message, "Error");
                  }
                }
              }

              if (parameterDownloadWindow != null) {
                if (this.terminalForm.controls['parameterDownloadWindowDay'].status == "VALID" && this.terminalForm.controls['parameterDownloadWindowTime'].status == "VALID") {
                  //Update parameter downloads
                  this.createResult = await this._terminalService.UpdateTerminalInteraction(InteractionTypeEnum.ParameterDownload, this.parameterDownloadWindowUpdate);
                  if (this.createResult.success === true) {
                    this._toastService.success(this.createResult.message, "Success");
                  } else {
                    this._toastService.error(this.createResult.message, "Error");
                  }
                }
              }
              else {
                if (this.terminalForm.controls['parameterDownloadWindowDay'].status == "VALID" && this.terminalForm.controls['parameterDownloadWindowTime'].status == "VALID") {
                  //Add parameter downloads
                  this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.ParameterDownload, this.parameterDownloadWindowUpdate);
                  if (this.createResult.success === true) {
                    this._toastService.success(this.createResult.message, "Success");
                  } else {
                    this._toastService.error(this.createResult.message, "Error");
                  }
                }
              }
            }
          }
        }

        if (this.terminal.termType == 350 && this.isSerialNrVisible) {
          this.createResult = await this._terminalService.AddUpdateTerminalInfo(this.terminalInfo);
        }

        if (this.terminal.termType == 103 && this.isSerialNrVisible) {
          debugger;
          this.eSocketTerminal.terminalConfigId = this.terminalSelectedConfig.terminalConfigId;
          this.createResult = await this._terminalService.UpdateESocket(this.eSocketTerminal);
          if (this.createResult.success == true) {
            this._toastService.success(this.createResult.message, "Success");

            this.createResult = await this._terminalService.AddUpdateTerminalInfo(this.terminalInfo);

          } else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseDanger = true;
            this.danger = this.createResult.message;

          }
        }

        this.UserPermissions();

        this._router.navigate(['management', 'terminal', this.terminalUpdate.terminalId]);

      } else {
        this._toastService.error(this.createResult.message, "Error");
        this.danger = this.createResult.message;
        this.raiseDanger = true;
      }
    }
    else {
      if (this.terminalUpdate.terminalConfigId == undefined || this.terminalUpdate.terminalConfigId == 0 || this.terminalUpdate.terminalConfigId == null) {
        this.danger = "Please select a config type";
        this.raiseDanger = true;
        return;
      }
      //add new terminal
      this.raiseDanger = false;

      if (this.TermConfigType == this.TermApp) {
        if (this.terminalUpdate.terminalActive == null) {
          this.terminalUpdate.terminalActive = false;
        }
        if (this.terminalUpdate.manualPanEntry == null) {
          this.terminalUpdate.manualPanEntry = false;
        }

        if (this.terminalForm.controls['merchantNumber'].status == 'INVALID' ||
          this.terminalForm.controls['terminalId'].status == 'INVALID' ||
          this.terminalForm.controls['terminalNumber'].status == 'INVALID' ||
          this.terminalForm.controls['terminalType'].status == 'INVALID' ||
          this.terminalForm.controls['productProfile'].status == 'INVALID' ||
          this.terminalForm.controls['terminalCapabilities'].status == 'INVALID' ||
          this.terminalForm.controls['commsProfile'].status == 'INVALID' ||
          this.terminalForm.controls['bankingWindowTime'].status == "INVALID" ||
          this.terminalForm.controls['parameterDownloadWindowDay'].status == "INVALID" ||
          this.terminalForm.controls['parameterDownloadWindowTime'].status == "INVALID") {

          this.danger = "Please provide required information.";
          this.raiseDanger = true;
        }
        else {

          this.createResult = await this._terminalService.Create(this.terminalUpdate);
          if (this.createResult.success === true) {
            this._toastService.success(this.createResult.message, "Success");

            // create ContactLess
            this.createResult = await this._terminalService.SetTerminalParam(this.contactlessTerminalParam);

            // create serial number
            if (this.isSerialNrVisible) {
              this.createResult = await this._terminalService.AddTerminalInfo(this.terminalInfo);
            }

            this.canAddTerminalInteraction = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalInteraction], []);
            if (this.canAddTerminalInteraction) {

              //add banking window - Terminal interactions
              if (this.terminalForm.controls['bankingWindowTime'].status == "VALID") {
                this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.BankingWindow, this.bankingWindowUpdate);
                if (this.createResult.success === true) {
                  this._toastService.success(this.createResult.message, "Success");
                }
                else {
                  this._toastService.error(this.createResult.message, "Error");
                }
              }

              //add parameter donwload - terminal interaction
              if (this.terminalForm.controls['parameterDownloadWindowDay'].status == "VALID" && this.terminalForm.controls['parameterDownloadWindowTime'].status == "VALID") {
                this.createResult = await this._terminalService.AddTerminalInteractions(InteractionTypeEnum.ParameterDownload, this.parameterDownloadWindowUpdate);

                if (this.createResult.success === true) {
                  this.createTerminal = true;
                  this._toastService.success(this.createResult.message, "Success");
                } else {
                  this._toastService.error(this.createResult.message, "Error");
                }
              }
              this.createTerminal = true;
            }
            else {
              this.createTerminal = true;
              this.danger = "";
              this.raiseDanger = false;
              this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this._userDataStore.selectedParticipant.id, Number(this.terminalUpdate.terminalConfigId));
              if (this.TerminalGroupsByParticipant.length > 0) {
                this.raiseWarning = true;
                this.warning = "Remember to capture Custom parameters!";
              }
              else {
                this._router.navigate(['management', 'terminal']);//, this.terminalUpdate.terminalId]
              }
            }
            //if parameter download successfull then redirect
            if (this.createTerminal) {
              this.TerminalGroupsByParticipant = await this._customTagService.GetGroupsByParticipantIdTerminalConfigId(this._userDataStore.selectedParticipant.id, Number(this.terminalUpdate.terminalConfigId));
              if (this.TerminalGroupsByParticipant.length > 0) {
                this.raiseWarning = true;
                this.warning = "Remember to capture Custom parameters!";
                this.filterTerminalGroups();
              }
              else {
                this._router.navigate(['management', 'terminal']);//, this.terminalUpdate.terminalId]
              }
            }

          }
          else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }
      }
      else if (this.TermConfigType == this.PostTerm) {
        //Create MPOS
        if (this.terminalForm.controls['merchantNumber'].status == 'INVALID' || this.terminalForm.controls['terminalId'].status == 'INVALID') {
          this.danger = "Please provide required information.";
          this.raiseDanger = true;
        }
        else {
          this.terminalUpdate.terminalType = 22;//generic
          this.createResult = await this._terminalService.Create(this.terminalUpdate);

          if (this.createResult.success === true) {
            this._toastService.success(this.createResult.message, "Success");
            this.raiseDanger = false;
            //this._router.navigate(['management/terminal']);
            this._router.navigate(['management', 'terminal']);//, this.terminalUpdate.terminalId
          } else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }

      }
      else if (this.TermConfigType == this.eSocket) {
        debugger;
        //Create eSocket
        if (this.terminalForm.controls['merchantNumber'].status == 'INVALID' || this.terminalForm.controls['terminalId'].status == 'INVALID' || this.terminalForm.controls['storeId'].status == 'INVALID' || this.terminalForm.controls['laneProfile'].status == 'INVALID') {
          this.danger = "Please provide required information.";
          this.raiseDanger = true;
        }
        else {
          this.terminalUpdate.terminalType = 103;//eSocket

          //validate esocket configuration

          this.createResult = await this._terminalService.ValidateEsocketTerminal(this.eSocketTerminal);
          if (this.createResult.success == true) {
            this.createResult = await this._terminalService.Create(this.terminalUpdate);
            if (this.createResult.success === true) {
              this._toastService.success(this.createResult.message, "Success");
              this.createResult = await this._terminalService.CreateESocket(this.eSocketTerminal);
              if (this.createResult.success === true) {
                this._toastService.success(this.createResult.message, "Success");

                if (this.isSerialNrVisible) {
                  this.createResult = await this._terminalService.AddTerminalInfo(this.terminalInfo);
                }
              } else {
                this._toastService.error(this.createResult.message, "Error");
                this.raiseDanger = true;

              }
              //this._router.navigate(['management/terminal']);
              this._router.navigate(['management', 'terminal']);//, this.terminalUpdate.terminalId
            } else {
              this._toastService.error(this.createResult.message, "Error");
              this.raiseDanger = true;
              this.danger = this.createResult.message;
            }
          }
          else {
            this._toastService.error(this.createResult.message, "Error");
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }

      }

      this.terminalForm.markAsPristine();
    }
    this._ngxUiLoaderService.stop();

  }

  public async deleteInactiveTerminal(): Promise<void> {
    const result = await this._terminalService.DeleteInactiveTerminal(this.terminal.id);

    if (result.success === true) {
      await this._router.navigate(['management', 'terminal']);
      this._toastService.success(result.message, "Success");
    } else {
      this._toastService.error(result.message, "Error");
    }
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.dtTrigger.unsubscribe();
  }

  public onReset() {
    this.submitted = false;
  }

  public async setContactless(value): Promise<void> {

    this.contactlessTerminalParam = {
      termId: this.terminalForm.controls['terminalId'].value,
      tag: 'TokenCless',
      fileId: null,
      valueOnServer: value.target.checked ? '1' : '0',
      lastUpdated: new Date(),
      valueStatus: null,
    };
  }

  public get isContactless() {
    return !!this.contactlessTerminalParam &&
      !!this.contactlessTerminalParam.valueOnServer &&
      this.contactlessTerminalParam.valueOnServer === '1';
  }

  public async addTerminalGroups(): Promise<void> {

    this.groupExist = false;
    this.tagExist = false;
    if (!!this.selectedGroup) {
      const mappedGroupFields = {
        term_group_name: this.selectedGroup,
        tag: '',
        fileId: '',
        valueOnServer: '',
        lastUpdated: null,
        valueStatus: 0
      };
      const fc = new FormControl();
      //fc.setValue(mappedFields.mappedCardAcceptorId);

      if (this.terminalGroupMappedFields != null) {
        if (this.terminalGroupMappedFields.length > 0) {
          var item = this.terminalGroupMappedFields.find(x => x.term_group_name == mappedGroupFields.term_group_name)

          if (item != null) {
            this.raiseDanger = true;
            this.groupExist = true;
            this.danger = "Terminal group '" + mappedGroupFields.term_group_name + "' already exist.";
            //this._toastService.error("Terminal group '" + mappedGroupFields.term_group_name + "' already exist.", "Error");
            return;
          }
          else {
            this.raiseDanger = false;
            this.danger = "";
          }
        }
      }

      if (this.groupExist == false) {
        this.danger = ""
        this.raiseDanger = false;

        //save to database
        this._ngxUiLoaderService.start();

        //check if Custom parameters exist.

        var terminalParam = await this._customTagService.GetCustomTagsByParticipantIdTerminalConfigIdGroupName(this._userDataStore.selectedParticipant.id, this.termConfigId, this.selectedGroup);


        //check if terminal group has the same custom parameters with existing custom parameters.
        //this._ngxUiLoaderService.start();
        this.ClearCustomParameters();
        for (var i = 0; i < this.terminalGroupMappedFields.length; i++) {
          var tpf = await this._customTagService.GetCustomTagsByParticipantIdTerminalConfigIdGroupName(this._userDataStore.selectedParticipant.id, this.termConfigId, this.terminalGroupMappedFields[i].term_group_name);
          if (tpf != null && tpf.length > 0) {
            for (var p = 0; p < tpf.length; p++) {
              if (tpf[p].customTag != 'TokenCless') {
                this.terminalParamMappedFields.push(tpf[p]);
              }
            }
          }
        }

        if (this.terminalParamMappedFields != null && this.terminalParamMappedFields.length > 0) {
          this.terminalParamMappedFields.forEach(key => {
            if (terminalParam != null && terminalParam.length > 0) {
              terminalParam.forEach(mkey => {

                if (mkey.customTag == key.customTag) {
                  this.tagExist = true;
                  this.raiseDanger = true;
                  this.danger = "Custom parameters within group '" + mappedGroupFields.term_group_name + "' already been included on group '" + key.groupName + "'."
                  //this._toastService.error("Custom parameters within group '" + mappedGroupFields.term_group_name + "' already been selected.", "Error");
                  this.ClearCustomParameters();
                  return;
                }
              });
            }
          });
        }


        //check if terminal exist
        if (this.tagExist == false) {
          var term = await this._terminalService.GetTaTermCfg(this.terminalUpdate.terminalId);
          if (term != null && term.id != null) {
            this.createResult = await this._customTagService.AddTerminalGroupCustomParameters(mappedGroupFields, this.terminalUpdate.terminalId, this.termConfigId);
            if (this.createResult.success) {
              this._toastService.info(this.createResult.message);

              this.terminalGroupMappedFields = this.terminalGroupMappedFields || [];
              this.terminalGroupMappedFields.push(mappedGroupFields);
              this.mappedFieldsGroupFC.push({ formControl: fc, terminalGroupMappedFields: mappedGroupFields });


              //Sync RT with LC
              var result = this._customTagService.AddUpdateCustomTags(terminalParam, (this.id == undefined ? this.terminalUpdate.terminalId : this.id));
            }
            else {
              this._toastService.error(this.createResult.message);
            }
          }
          else {
            this._toastService.error("Terminal does not exist, Please save terminal before capturing Custom parameters.");
          }
        }

        this._ngxUiLoaderService.stop();

      }
      this.ClearCustomParameters();


    }
    this.filterTerminalGroups();
  }

  public async saveTerminalGroupAndParameters(): Promise<void> {

    this._ngxUiLoaderService.start();
    if (this.terminalGroupMappedFields.length > 0) {
      //check if terminal exist
      var term = await this._terminalService.GetTaTermCfg(this.terminalUpdate.terminalId);
      if (term != null && term.id != null) {
        this.createResult = await this._customTagService.SaveTerminalGroupCustomParameters(this.terminalGroupMappedFields, this.terminalUpdate.terminalId, this.termConfigId);
        if (this.createResult.success) {
          this._toastService.info(this.createResult.message);
        }
        else {
          this._toastService.error("Error occured while updating entries. Contact system administrator");
        }
      }
      else {
        this._toastService.error("Terminal does not exist yet, Please save terminal before capturing Custom parameters.");
      }
    }
    else {
      this._toastService.error("Please add terminal group.");
    }

    this._ngxUiLoaderService.stop();

  }

  public async ViewCustomParameters(group: string): Promise<void> {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminal], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);


    //clear list

    this.selectedTerminalGroup = 'for Terminal group: ' + group;
    this.globalTerminalGroup = group;
    this.ClearCustomParameters();
    this._ngxUiLoaderService.start();
    var nodes = (await this._customTagService.GetCustomTagsByTerminalID((this.id == undefined ? this.terminalUpdate.terminalId : this.id), group, this._userDataStore.selectedParticipant.id, this.termConfigId));
    if (nodes.length == 0) {
      this.noCustomParamterSet = true;
      this.noCustomParamterMessage = "No Custom parameter set against this group";
    }
    else {
      this.noCustomParamterSet = false;
      this.noCustomParamterMessage = "";

      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].customTag != 'TokenCless') {
          this.terminalParamMappedFields.push(nodes[i]);
        }
      }

      if (this.terminalParamMappedFields) {

        var groupN = (await this._customTagService.GetGroupByParticipantIdTerminalConfigIdGroupName(this._userDataStore.selectedParticipant.id, this.termConfigId, group));
        if (groupN != null) {
          var n = groupN.customParameterEditable;//group.includes("Custom");
          if (n == false) {
            this.EditCustomParam = "display:none;";
            this.cssClass = "form-control frans";
          }
          else {
            this.EditCustomParam = "display:block;";
            this.cssClass = "form-control";
          }

          for (const item of this.terminalParamMappedFields) {
            const mappedField = new FormControl();
            if (item.fileId == null || item.fileId == '') {
              mappedField.setValue("" + item.value);
            }
            else {
              mappedField.setValue("" + item.fileId);
            }
            if (!this.canEdit && this.canView) {
              mappedField.disable();
            }
            this.mappedFieldsFC.push({ formControl: mappedField, terminalParamMappedFields: item });
          }

        }
        else {
          this.EditCustomParam = "display:none;";
          this.cssClass = "form-control frans"

        }
      }
    }
    this._ngxUiLoaderService.stop();
  }

  public ClearCustomParameters(): void {

    this.terminalParamMappedFields.splice(0);
    this.mappedFieldsFC.splice(0);
  }


  public async defaultValueChange(event, index, oldValue): Promise<void> {

    const value = event;
    var ele = document.getElementById(index);

    var ele1 = document.getElementById(oldValue + "" + oldValue);

    if (value !== oldValue) {
      ele.style.border = "3px solid red";
      ele1.style.color = "red";
      ele1.innerText = "Remember to click the 'Update' button to complete the operation.";

    } else {
      ele.style.backgroundColor = "white";
      ele1.style.color = "";
      ele1.innerText = "";
    }
  }

  public async deleteTerminalGroup(groupName: string): Promise<void> {



    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Terminal group removal"
    dialogRef.componentInstance.message = "Are you sure you want to delete the selected terminal group?"

    const result = await dialogRef.result;
    if (result) {
      this._ngxUiLoaderService.start();

      this.createResult = await this._customTagService.DeleteTerminalGroupByTerminalIdGroupName(this.terminalUpdate.terminalId, groupName, this.termConfigId);
      if (this.createResult.success) {

        if (this.terminalGroupMappedFields != null) {
          if (this.terminalGroupMappedFields.length > 0) {
            var item = this.terminalGroupMappedFields.findIndex(x => x.term_group_name == groupName)

            if (item != null) {
              this.terminalGroupMappedFields.splice(item, 1);
              this.mappedFieldsGroupFC.splice(item, 1);
            }
          }
        }

        this._toastService.info('Terminal group deleted.');

        this.selectedTerminalGroup = '';
        this.ClearCustomParameters();
      }
      else {
        this._toastService.error(this.createResult.message);
      }

      this._ngxUiLoaderService.stop();
    }

    this.filterTerminalGroups();
  }

  public async updateCustomParamters(customTag: string): Promise<void> {


    this._ngxUiLoaderService.start();
    var param = '';

    for (const mappedField of this.mappedFieldsFC) {
      if (mappedField.terminalParamMappedFields.customTag === customTag) {
        param = "" + mappedField.formControl.value;
      }
    }


    var item = this.terminalParamMappedFields.find(x => x.customTag == customTag)
    if (item != null) {

      const mappedFields = {
        id: item.id,
        customTag: item.customTag,
        groupName: item.groupName,
        participantId: item.participantId,
        terminalConfigId: item.terminalConfigId,
        value: param,
        valid: item.valid,
        fileId: item.fileId
      };

      const index = this.terminalParamMappedFields.findIndex(x => x.customTag == customTag);

      if (index > -1) {

        //update database or default value.
        this.createResult = await this._customTagService.UpdateDefaultValueByRecordId(mappedFields);

        if (this.createResult.success) {
          //delete from the list

          this.terminalParamMappedFields.splice(index, 1);
          this.mappedFieldsFC.splice(index, 1);

          // add
          const fc = new FormControl();
          fc.setValue("" + param);
          this.terminalParamMappedFields = this.terminalParamMappedFields || [];
          this.terminalParamMappedFields.push(mappedFields);
          this.mappedFieldsFC.push({ formControl: fc, terminalParamMappedFields: mappedFields });


          this._toastService.success("Update completed.");
        } else {
          this._toastService.error("Error updating record. Contact systm administrator.");
        }
      }
    }


    this._ngxUiLoaderService.stop();

  }

  public async UpdateCustomParam(customParam: string, custonValue: string, oldValue: string): Promise<void> {



    const value = event;
    var ele1 = document.getElementById(oldValue + "" + oldValue);
    if (ele1 != null) {
      ele1.style.color = "";
      ele1.innerText = "";
    }
    var ele = document.getElementById(customParam);
    if (ele != null) {
      ele.style.border = "1px solid #ced4da";

    }
    var customParam_ = {
      customTag: customParam,
      participantId: this._userDataStore.selectedParticipant.id,
      terminalConfigId: this.termConfigId,
      value: custonValue,
      groupName: this.globalTerminalGroup,
      id: 0,
      valid: true
    }

    //this.createResult = await this._customTagService.UpdateLDCustomParameter(customParam_);
    //if (this.createResult.success) {

    this.createResult = await this._customTagService.UpdateRTCustomParameter(customParam, custonValue, this.terminalUpdate.terminalId);

    if (this.createResult.success) {
      this._toastService.success(this.createResult.message, 'Success');
    } else {
      this._toastService.error(this.createResult.message, 'Error');
    }
    //}
    //else {
    //  this._toastService.error(this.createResult.message, 'Error');
    //}
  }

  public async filterTerminalGroups(): Promise<void> {

    const filteredItems = this.terminalGroups.filter((item) => {

      if (this.terminalGroupMappedFields != null) {
        const index = this.terminalGroupMappedFields.findIndex(x => x.term_group_name.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapTerminalGroupTags = filteredItems;
  }


}

